import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import { getField, updateField } from "vuex-map-fields";
import dayjs from "dayjs";
import { EventBus } from "@/services/EventBus.js";
import Routes from "@/modules/form.js";

Vue.use(Vuex);

function setDefaultDate() {
  if (dayjs().hour() > 14) {
    return dayjs()
      .add(1, "day")
      .format("YYYY-MM-DD");
  } else {
    return dayjs().format("YYYY-MM-DD");
  }
}

const getters = {
  getField
};

const mutations = {
  setFormComplete(state, val = true) {
    state.complete = val;
  },
  setCountdownTimer(state, val) {
    state.countdownTimer = val;
  },
  setBID(state, b_id) {
    state.form_fields.b_id = b_id;
  },
  setComplete( bit ) {
    state.complete = bit;
  },
  setPaymentError( state, responseError ) {
    state.paymentError = responseError;
  },
  setDepartingPassengers(state, paxArr) {
    paxArr.forEach(p => {
      const keys = Object.keys(p);
      const k = keys[0];
      const field = "pax_" + k;
      state.form_fields[field] = p[k];
    });
  },
  setReturningPassengers(state, paxArr) {
    paxArr.forEach(p => {
      const keys = Object.keys(p);
      const k = keys[0];
      const field = "pax_" + k + "_r";
      state.form_fields[field] = p[k];
    });
  },
  openDialog(state, which) {
    state[which + "Dialog"] = !state[which + "Dialog"];
  },
  editFlightSelect(state) {
    console.log("---> editFlightSelect");
  },
  fillForm(state, which) {
    console.log("Auto-filling form...");
    if (state.form_fields.dep_loc === 0) {
      state.form_fields.dep_date = dayjs().add(1, "day").format("YYYY-MM-DD");
      state.form_fields.ret_date = dayjs().add(2, "day").format("YYYY-MM-DD");
      state.form_fields.dep_loc = 5;
      state.form_fields.dest_loc = 10;
      state.form_fields.pax_a = 2;
      state.form_fields.pac_c = 1;
      state.form_fields.pax_i = 1;
    }
    if (state.user.id === null) {
      console.log("-> Setup user");
      state.user.id = null;
      state.user.name_first = "John";
      state.user.name_last = "Smith";
      state.user.email = "james@primalcom.ca";
      state.user.password = "primal";
      state.user.phone.cell = "250-555-1234";
      state.user.phone.alt = "250-555-3456";
    }
    state.user.address.street = "123 Picka St";
    state.user.address.street2 = "Apartment 7";
    state.user.address.city = "Nanaimo";
    state.user.address.country = "Canada";
    state.user.address.province = "British Columbia";
    state.user.address.postal_code = "V9R 3B7";
    state.user.credit_card.cardholder = "Test Cardholder";
    state.user.credit_card.number = "5555555555555555";
    state.user.credit_card.expires.mm ="12";
    state.user.credit_card.expires.yy = "19";
    state.user.credit_card.cvv = "123";
		state.form_fields.agree_to_terms = true;
		state.form_fields.hcaptchaToken = null;

    let t = [
      state.departFlight !== null ? state.departFlight : null,
      state.returnFlight !== null ? state.returnFlight : null
    ];
    let discounts = {
      student: false,
      senior: false
    };
    let pCount = 0;
    t.forEach(f => {
      if (f != null) {
        let pass = f.passengers;
        if (pass !== undefined) {
          Object.keys(pass).forEach(p => {
            let pGroup = pass[p];
            if (pGroup.length > 0) {
              for (let x = 0; x < pGroup.length; x++) {
                pCount++;
                if (
                  pass[p][x].fname === "" ||
                  pass[p][x].fname === null
                ) {
                  pass[p][x].fname = (Math.round(Math.random()) === 1) ? "Test " + pCount : "Tester " + pCount;
                  pass[p][x].lname = (Math.round(Math.random()) === 1) ? "Testinksy" : "Testerson";
                  pass[p][x].gender = (Math.round(Math.random()) === 1) ? "Female" : "Male";
                  if (pass[p][x].group === "Adult") {
                    let d1 = Math.round(Math.random());
                    let d2 = Math.round(Math.random());
                    if (d1 === 1) {
                      discounts.student = true;
                      d2 = 0;
                    } else {
                      if (d2 === 1) discounts.senior = true;
                      d1 = 0;
                    }
                    pass[p][x].discounts[0].value = (d1 === 1) ? true : false;
                    pass[p][x].discounts[1].value = (d2 === 1) ? true : false;
                  }
                }
              }
            }
          });
        }
      }
    });
    state.conditions.student = discounts.student;
    state.conditions.senior = discounts.senior;
  },
  setdarkMode(state, mode) {
    state.darkMode = mode;
  },
  setShowCountdownTimer(state, mode) {
    state.showCountdownTimer = mode;
  },
  setMinimalMode(state, mode) {
    state.minMode = mode;
  },
  setColMode(state, mode) {
    state.colMode = mode;
  },
  setPrepaid(state, mode) {
    state.user.has_prepaid = mode;
    if (mode === false) {
      state.form_fields.use_prepaid = false;
    }
	},
  showHideForm(state) {
    state.showForm = (state.showForm === false) ? true : false;
  },
  setActiveStep(state, step) {
    state.active = step;
  },
  enableForm(state, label) {
    let forms = state.form[0].children;
    forms.forEach(f => {
      if (f.name === label) {
        f.active = true;
      }
    });
  },
  disableForm(state, label) {
    let forms = state.form[0].children;
    forms.forEach(f => {
      if (f.name === label) {
        f.active = false;
      }
    });
  },
  setEditMode(state, val) {
    state.editMode = val;
  },
  setEditBookingData(state, val) {
    state.editBookingData = val;
  },
  saveFlightDetails(state, payload) {
    const u = payload.user;
    state.loading = true;
    state.editMode = true;
    state.complete = false;
    state.departFlight = null;
    state.returnFlight = null;
    state.departingFlights = null;
    state.returningFlights = null;
    state.form_steps_complete = [];
    state.line_items = null;
    state.lowest_fares = null;
		state.samepassengers = true;
		state.promocode = "";
		state.form_fields.hcaptchaToken = null;
    state.form_fields.agree_to_terms = false;

    let uID = state.user.id;
    if (uID !== null) {
      if (Number(uID) !== Number(u.id)) {
        console.log("User mismatch: orig/new: ", uID, u.id);
      }
    } else {
      uID = Number(u.id);
    }
    const user = {
      id: uID,
      name_first: u.name_first,
      name_last: u.name_last,
      email: u.email,
      password: "",
      phone: {
        cell: u.phone.cell,
        alt: u.phone.alt
      },
      address: {
        street: "",
        street2: "",
        city: "",
        country: "CA",
        province: "BC",
        postal_code: ""
      },
      credit_card: {
        cardholder_fn: "",
        cardholder_ln: "",
        number: "",
        expires: {
          mm: "",
          yy: ""
        },
        cvv: ""
      },
			has_prepaid: u.has_prepaid,
			promocode: "",
			hcaptchaToken: null,
    };
    state.user = { ...user };

    let cond = state.conditions;
    Object.keys(cond).forEach(c => {
      cond[c] = false;
    });
    state.active = 1;
    let form_fields = {
      b_id: state.form_fields.b_id * 1,
      dep_loc: 0,
      dest_loc: 0,
      dep_date: setDefaultDate(),
      ret_date: null,
      pax_a: 1,
      pax_c: 0,
      pax_i: 0,
      pax_a_r: 1,
      pax_c_r: 0,
      pax_i_r: 0,
      round_trip: false,
			use_prepaid: false,
			promocode: "",
			agree_to_terms: false,
			hcaptchaToken: null
    };
    state.form_fields = form_fields;

    if (payload.fields.dep_date !== undefined) {
      state.form_fields.dep_date = dayjs(payload.fields.dep_date).format("YYYY-MM-DD");
      state.form_fields.dep_loc = payload.fields.dep_loc * 1;
      state.form_fields.dest_loc = Number(payload.fields.dest_loc) * 1;
      state.form_fields.pax_a = Number(payload.fields.pax_a) * 1;
      state.form_fields.pax_c = Number(payload.fields.pax_c) * 1;
      state.form_fields.pax_i = Number(payload.fields.pax_i) * 1;
			state.form_fields.use_prepaid = payload.fields.use_prepaid;
			state.form_fields.promocode = payload.fields.promocode;
			state.form_fields.agree_to_terms = payload.fields.agree_to_terms;
			state.form_fields.hcaptchaToken = payload.fields.hcaptchaToken;
			state.form_fields.round_trip = payload.fields.round_trip;

      state.departFlight = {};

      if (payload.fields.ret_date !== undefined) {
        state.form[0].children[1].active = true;
        state.form_fields.ret_date = dayjs(payload.fields.ret_date).format("YYYY-MM-DD");
        if (
          payload.fields.pax_a_r !== undefined &&
          payload.fields.pax_a_r > 0
        ) {
          state.samepassengers = false;
          state.form_fields.pax_a_r = Number(payload.fields.pax_a_r) * 1;
          state.form_fields.pax_c_r = Number(payload.fields.pax_c_r) * 1;
          state.form_fields.pax_i_r = Number(payload.fields.pax_i_r) * 1;
          state.returnFlight = {};
        }
        state.form[0].children[1].active = true;
        state.form_steps_complete.push("Return");
      } else {
        state.form[0].children[1].active = false;
      }
    }
    let t = [
      payload.dep.passengers !== undefined ? "depart" : null,
      payload.ret.passengers !== undefined ? "return" : null,
    ];
    let pCount = 0;
    for (let x = 0; x < t.length; x++) {
      if (t[x] !== null) {
        const flight = t[x] + "Flight";
        const payload_flight = t[x] === "depart" ? payload.dep : payload.ret;
        let pax = payload_flight.passengers;
        if (typeof pax === "object" && Array.isArray(pax) === false) {
          let tPax = {};
          Object.keys(pax).forEach(key => {
            if (pax[key].length > 0) {
              for (let y = 0; y < pax[key].length; y++) {
                if (pax[key][y].id === undefined) {
                  pax[key][y].id = pCount;
                }
                pCount++;
              }
              tPax[key] = pax[key];
            }
          });
          pax = tPax;
        }
        const fObj = {
          departs: payload_flight.departs,
          type: t[x],
          f_id: payload_flight.f_id,
          f_no: payload_flight.f_no,
          fare: { ...payload_flight.fare },
          passengers: pax
        };
        state[flight] = { ...fObj };
      }
    }
    state.form_fields = form_fields;
    state.form_steps_complete.push("Passenger Count");
    state.form_steps_complete.push("Dates");
    state.form_steps_complete.push("Locations");
    state.form_steps_complete.push("Departing");
    state.form_steps_complete.push("Account");
    state.form_steps_complete.push("Contact");

    state.errors = [];
    state.editBookingData = { ...payload };
    state.loading = false;
  },
  setFormFields(state, payload) {
    state.form[0].children = payload;
  },
  replaceForms(state, formsArr) {
    state.form[0].children = formsArr;
  },
  setDepartLoc(state, loc) {
    state.form_fields.dep_loc = loc;
  },
  setDestLoc(state, loc) {
    state.form_fields.dest_loc = loc;
  },
  setDeptDate(state, date) {
    state.form_fields.dep_date = date;
    if (state.departFlight !== null) {
      state.departFlight = null;
    }
    if (state.departingFlights !== null) {
      state.departingFlights = null;
    }
  },
  setRetDate(state, date) {
    state.form_fields.ret_date = date;
    if (date === "" || date === null) {
      state.form_fields.round_trip = false;
    } else {
      state.form_fields.round_trip = true;
    }
  },
  setLoading(state, val) {
    state.loading = val;
  },
  setLoading2(state, val) {
    state.loading2 = val;
  },
  setLoadingUser(state, val) {
    state.loadingUser = val;
  },
  setStepFieldComplete(state, payload) {
    state.form[0].children[payload[0]].meta.fields[
      payload[1]
    ].status.complete = true;
  },
  setAgreeToTerms(state, val) {
    state.form_fields.agree_to_terms = val;
  },
  resetComplete(state) {
    state.complete = false;
    state.form_steps_complete = [];
  },
  setStepIncomplete(state, label) {
    let complete = state.form_steps_complete.filter(f => f !== label);
    state.form_steps_complete = complete;
  },
  setStepComplete(state, label) {
    if (
      state.form_steps_complete.find(f => {
        return f == label;
      }) === undefined
    ) {
      state.form_steps_complete.push(label);
    }
  },
  checkPaxDiscountsDepart(state, payload) {
    for( let i = 0; i<payload.Adult; i++ )
    {
      state.departFlight.passengers.Adult[i].discounts[0].value = false;
      state.departFlight.passengers.Adult[i].discounts[1].value = false;
    }
  },
  checkPaxDiscountsReturn(state, payload) {
    for( let i = 0; i<payload.Adult; i++ )
    {
      state.returnFlight.passengers.Adult[i].discounts[0].value = false;
      state.returnFlight.passengers.Adult[i].discounts[1].value = false;
    }
  },
  setReturningFlight(state, payload) {
    if (payload.passengers === undefined) {
      if (
        state.returnFlight !== null &&
        state.returnFlight.passengers !== undefined
      ) {
        payload.passengers = state.returnFlight.passengers;
      } else if (
        state.editMode === true &&
        state.editBookingData.ret.passengers !== undefined
      ) {
        payload.passengers = state.editBookingData.ret.passengers;
      }
    }
    state.returnFlight = payload;
  },
  setDepartingFlight(state, payload) {
    if (payload.passengers === undefined) {
      if (
        state.departFlight !== null &&
        state.departFlight.passengers !== undefined
      ) {
        payload.passengers = state.departFlight.passengers;
      } else if (
        state.editMode === true &&
        state.editBookingData.dep.passengers !== undefined
      ) {
        payload.passengers = state.editBookingData.dep.passengers;
      }
    }
    state.departFlight = payload;
  },
  resetDepartFlight(state) {
    state.departFlight = null;
  },
  resetDepartingFlights(state) {
    state.departingFlights = null;
  },
  resetReturnFlight(state) {
    state.returnFlight = null;
  },
  resetReturningFlights(state) {
    state.returningFlights = null;
  },
  resetFormFields(state) {
    const defaultFields = {
      b_id: null,
      dep_loc: 0,
      dest_loc: 0,
      dep_date: setDefaultDate(),
      ret_date: null,
      pax_a: 1,
      pax_c: 0,
      pax_i: 0,
      pax_a_r: 1,
      pax_c_r: 0,
      pax_i_r: 0,
      round_trip: false,
			use_prepaid: false,
			promocode: "",
			agree_to_terms: false,
			hcaptchaToken: null
    };
    state.form_fields = { ...defaultFields };
  },
  addPax(state, payload) {
    state.form_fields[payload[0]] = payload[1];
  },
  addPassenger(state, payload) {
    const flight = payload[0];
    const type = payload[1];
    const index = payload[2];
    const p = payload[3];
    if (state[flight].passengers[type] === undefined) {
      state[flight].passengers[type] = [type];
    }
    if (state[flight].passengers[type][index] === undefined) {
      state[flight].passengers[type][index] = { ...p };
    }
  },
  setDepartDate(state, payload) {
    state.form_fields.dep_date = payload;
  },

  setErrorState(state, payload) {
    const label = payload[0];
    const msg = payload[1];
    let forms = state.form[0].children;
    for (let x = 0; x < forms.length; x++) {
      let form = forms[x];
      if (form.meta.fields !== undefined) {
        for (let y = 0; y < form.meta.fields.length; y++) {
          let field = form.meta.fields[y];
          if (field.label == label) {
            forms[x].meta.fields[y].status.error = true;
            forms[x].meta.fields[y].status.complete = false;
            forms[x].meta.fields[y].status.errorDetails = msg;
          }
        }
        let match = false;
        for (let e = 0; e < state.errors.length; e++) {
          if (label == state.errors[e].label) {
            match = true;
          }
        }
        if (match !== true) {
          state.errors.push({
            label: label,
            msg: msg
          });
        }
      }
    }
  },
  unsetAllErrors(state) {
    const errors = state.errors;
    errors.forEach(e => {
      this.commit("unsetQuickErrors", e.label);
      this.commit("unsetErrorState", e.label);
    });
  },
  unsetErrorState(state, payload) {
    let sec = state.form[0].children;
    let setChildren = false;
    sec.forEach(s => {
      if (s.name.toLowerCase() === payload.toLowerCase()) {
        setChildren = true;
      }
      let fields = s.meta.fields;
      if (fields != undefined) {
        fields.forEach(field => {
          if (
            field.label.toLowerCase() === payload.toLowerCase() ||
            setChildren === true
          ) {
            field.status.error = false;
            field.status.errorDetails = "";
          }
        });
      } else if (s.name.toLowerCase() === payload.toLowerCase()) {
        s.meta.status.error = false;
        s.meta.status.errorDetails = "";
      }
    });
  },
  unsetQuickErrors(state, label) {
    let eArr = [];
    state.errors.forEach(e => {
      if (e.label != label) eArr.push(e);
    });
    state.errors = eArr;
  },
  setGender(state, payload) {
    let pid = payload[0];
    let v = payload[1];
    let t = [
      state.departFlight !== null ? state.departFlight : null,
      state.returnFlight !== null ? state.returnFlight : null
    ];

    t.forEach(f => {
			if (f !== null && typeof f.passengers === "object") {
        let pass = f.passengers;
        Object.keys(pass).forEach(p => {
          let pGroup = pass[p];
          pGroup.forEach(pass => {
            if (pass.id == pid) {
              pass.gender = v;
              return;
            }
          });
        });
      }
    });
  },
  setDiscount(state, passenger) {
    let pID = passenger.id;
    let disc = passenger.discounts;
    let removeDisc = disc.length;

    let t = [
      state.departFlight !== null ? state.departFlight : null,
      state.returnFlight !== null ? state.returnFlight : null
    ];
    let discountFlag = {
      Student: false,
      Senior: false
    };
    t.forEach(f => {
      if (f !== null) {
        let pass = f.passengers;
        if (pass !== undefined) {
          Object.keys(pass).forEach(p => {
            let pGroup = pass[p];
            if (typeof pGroup === "object") {
              Object.keys(pGroup).forEach(key => {
                let p = pGroup[key];
                if (pass.id === key) {
                  pass.discounts.forEach(pd => {
                    if (removeDisc > 0) {
                      disc.forEach(d => {
                        if (d.value === true) discountFlag[d.name] = true;
                        if (d === pd.name) {
                          pd.value = true;
                        } else if (removeDisc < Object.keys(pd).length) {
                          pd.value = false;
                        }
                      });
                    } else {
                      pd.value = false;
                    }
                  });
                }
              });
            } else if (pGroup.isArray()) {
              pGroup.forEach(pass => {
                if (pass.id === pID) {
                  pass.discounts.forEach(pd => {
                    if (removeDisc > 0) {
                      disc.forEach(d => {
                        if (d.value === true) discountFlag[d.name] = true;
                        if (d === pd.name) {
                          pd.value = true;
                        } else if (removeDisc < Object.keys(pd).length) {
                          pd.value = false;
                        }
                      });
                    } else {
                      pd.value = false;
                    }
                  });
                }
              });
            }
          });
        }
      }
    });
    if (discountFlag.Student === true) state.conditions.student = true;
    if (discountFlag.Senior === true) state.conditions.senior = true;
  },
  setRoundTrip(state, val) {
    state.form_fields.round_trip = val;
  },
  showError(state, val) {
    state.showError = val;
  },
  set_field() {
    // Set from form_fields
  },
  saveUser(state, user) {
    if (user.error !== undefined) {
      return;
    }
    const u = user.user;
    state.user.id = u.id * 1;
    state.user.name_first = u.firstname;
    state.user.name_last = u.lastname;
    state.user.email = u.email;
    state.user.phone.cell = u.phone1;
    state.user.phone.alt = u.phone2;
    state.user.has_prepaid = u.has_prepaid;
  },
  logoutUser(state) {
    console.log("TCL: logout");
    const userDefault = {
      id: null,
      name_first: "",
      name_last: "",
      email: "",
      password: "",
      phone: {
        cell: "",
        alt: ""
      },
      address: {
        street: "",
        street2: "",
        city: "",
        country: "CA",
        province: "BC",
        postal_code: ""
      },
      credit_card: {
        cardholder: "",
        number: "",
        expires: {
          mm: "",
          yy: ""
        },
        cvv: ""
      },
			has_prepaid: false,
			promocode: ""
    };
    state.user = { ...userDefault };
  },
  saveDepartingFlights(state, data) {
    state.departingFlights = data;
    EventBus.$emit("departingFlightsLoaded", {});
  },
  loadPaxObj(state, obj) {
    const pax = state[obj.name].passengers;
    Object.keys(pax).forEach(p => {
      if (p === obj.type) {
        pax[p] = obj.pax;
      }
    });
  },
  saveReturningFlights(state, data) {
    state.returningFlights = data;
    EventBus.$emit("returningFlightsLoaded", {});
  },
  loadingLowestFares(state, val) {
    state.loadingLowest = val;
  },
  addBookingLineItems(state, payload) {
    state.line_items = payload;
  },
  addNextLowestFare(state, payload) {
    let nFares = [];
    const fare = payload[0];
    const params = payload[1];
    const lFares = state.lowestFares[params.dir];
    lFares.forEach((f, i) => {
      let ni = i + 1;
      if (params.row_shift === "right" && ni < lFares.length) {
        if (lFares[ni] !== undefined) {
          nFares[i] = lFares[ni];
          if (ni === lFares.length - 1) {
            nFares[ni] = fare;
          }
        }
      } else if (params.row_shift === "left") {
        ni = i - 1;
        if (ni > 0 && lFares[ni] !== undefined) {
          nFares.push(lFares[ni]);
        } else {
          nFares[ni] = fare;
          nFares.push(lFares[ni]);
        }
      }
    });
    state.lowestFares[params.dir] = [];
    state.lowestFares[params.dir] = nFares;
  },
  addLowestFare(state, payload) {
    const lF = state.lowestFares[payload.dir];
    let cached = false;
    for (let x = 0; x < lF.length; x++) {
      if (lF[x].date === payload.date) cached = true;
    }
    if (cached !== true) {
      lF.push(payload);
      lF.sort((a, b) => {
        return dayjs(a.date).isBefore(dayjs(b.date)) ? 0 : 1;
      });
      state.lowestFares[payload.dir] = lF;
    }
  },
  clearLowestFares(state) {
    state.lowestFares.D = [];
    state.lowestFares.R = [];
  },
  setTimeLimitScale(state, payload) {
    const tL = {
      scale: payload,
      value: state.timeLimit.value
    };
    state.timeLimit = tL;
  },
  setTimeLimitValue(state, payload) {
    const tL = {
      scale: state.timeLimit.scale,
      value: payload
    };
    state.timeLimit = tL;
  },
  setTimer(state, time) {
    state.timer = time;
  },
  setLowestFaresBaseDate(state, payload) {
    state.lowestFares[payload[0]] = payload[1];
  },
  setSamePassengers(state, val) {
    state.samepassengers = val;
  },
  setStudent(state, val) {
    state.conditions.student = val;
  },
  setSenior(state, val) {
    state.conditions.senior = val;
  },
  resetLineItems(state) {
    state.line_items = null;
  },
  resetLowestFares(state) {
    state.lowestFares.D = [];
    state.lowestFares.R = [];
  },
  resetTimers(state) {
    state.timer = dayjs();
    state.countdownTimer = "";
  },
  resetConditions(state) {
    state.conditions.senior = false;
    state.conditions.student = false;
    state.conditions.pets = false;
    state.conditions.dog = false;
    state.conditions.large_dog = false;
    state.conditions.cat = false;
    state.conditions.assistance = false;
  },
	resetCCForm(state) {
		state.user.credit_card.cardholder_fn = '';
		state.user.credit_card.cardholder_ln = '';
		state.user.credit_card.number = '';
		state.user.credit_card.expires.mm = '';
		state.user.credit_card.expires.yy = '';
		state.user.credit_card.cvv = '';
	},
  setDevMode(state, val) {
    console.log("TCL: setDevMode -> process.env.VUE_APP_DEVMODE", process.env.VUE_APP_DEVMODE);
    if (
      process.env.VUE_APP_DEVMODE === true ||
      process.env.VUE_APP_DEVMODE === "true"
    ) {
      state.devMode = val;
      console.log("Set DEV MODE: ", state.devMode);
    } else {
      console.log("DEV Mode not available in this environment.");
    }
  },
  updateField
};

const actions = {
  LOAD_URL_PARAMS(context, params = {}) {
    if (params.from !== state.form_fields.dep_loc) context.commit("setDepartLoc", params.from);
    if (params.to !== state.form_fields.dest_loc) context.commit("setDestLoc", params.to);
    if (params.date !== state.form_fields.dep_date) context.commit("setDeptDate", params.date);
    if (
      params.return !== undefined &&
      params.return !== false &&
      params.return !== "Invalid Date" &&
      params.return !== null
    ) {
      if (state.form_fields.ret_date !== params.return) {
        context.commit("setRetDate", params.return);
        context.commit("setRoundTrip", true);
        if (state.samepassengers !== true) {
          context.commit("setReturningPassengers", params.pax);
        }
      }
    } else {
      context.commit("setRetDate", null);
      context.commit("setRoundTrip", false);
    }
    context.commit("setDepartingPassengers", params.pax);
    context.commit("setStepComplete", "Passenger Count");
    context.commit("setStepComplete", "Dates");
    context.commit("setStepComplete", "Locations");
  },
  RESET_FORM_DATA(context) {
    const a = { a: 1 };
    const a_r = { a: 1 };
    const c = { c: 0 };
    const i = { i: 0 };
    const depart_pax = [a, c, i];
    const return_pax = [a_r, c, i];
    context.commit("setEditMode", false);
    context.commit("resetComplete");
    context.commit("setAgreeToTerms", false);
    context.commit("resetLineItems");
    context.commit("setDepartingPassengers", depart_pax);
    context.commit("setStepIncomplete", "Passengers");
    context.commit("setReturningPassengers", return_pax);
    context.commit("setStepIncomplete", "Returning Passengers");
    context.commit("resetDepartFlight");
    context.commit("resetDepartingFlights");
    context.commit("resetReturnFlight");
    context.commit("resetReturningFlights");
    context.commit("resetFormFields");
    context.commit("setDepartLoc", 0);
    context.commit("setDestLoc", 0);
    context.commit("setDeptDate", setDefaultDate());
    context.commit("setRetDate", null);
    context.commit("setSamePassengers", true);
    context.commit("resetLowestFares");
    context.commit("setRoundTrip", false);
    context.commit("setSenior", false);
    context.commit("setStudent", false);
    context.commit("resetConditions");
    context.commit("unsetAllErrors");
		context.commit("resetCCForm");

    context.commit('resetLowestFares');

    context.commit("setEditBookingData", null);


    context.commit("setStepComplete", "Passenger Count");
    context.commit("setStepComplete", "Dates");

    context.commit("resetTimers");
    context.commit("setLoading", false);
    context.commit("setLoading2", false);
    context.commit("setLoadingUser", false);
    context.commit("setActiveStep", 1);
  },
  RESET_FORM_DATA_EXCEPT_DEPART(context) {
    const a = { a: 1 };
    const a_r = { a: 1 };
    const c = { c: 0 };
    const i = { i: 0 };
    const depart_pax = [a, c, i];
    const return_pax = [a_r, c, i];
    context.commit("setEditMode", false);
    context.commit("resetComplete");
    context.commit("setAgreeToTerms", false);
    context.commit("resetLineItems");
    context.commit("setDepartingPassengers", depart_pax);
    context.commit("setStepIncomplete", "Passengers");
    context.commit("setReturningPassengers", return_pax);
    context.commit("setStepIncomplete", "Returning Passengers");
    // context.commit("resetDepartFlight");
    context.commit("resetDepartingFlights");
    context.commit("resetReturnFlight");
    context.commit("resetReturningFlights");
    context.commit("resetFormFields");
    // context.commit("setDepartLoc", 0);
    // context.commit("setDestLoc", 0);
    // context.commit("setDeptDate", setDefaultDate());
    context.commit("setRetDate", null);
    context.commit("setSamePassengers", true);
    // context.commit("resetLowestFares");
    context.commit("setRoundTrip", false);
    context.commit("setSenior", false);
    context.commit("setStudent", false);
    context.commit("resetConditions");
    context.commit("unsetAllErrors");
		context.commit("resetCCForm");

		context.commit('resetLowestFares');


    context.commit("setEditBookingData", null);


    context.commit("setStepComplete", "Passenger Count");
    context.commit("setStepComplete", "Dates");

    context.commit("resetTimers");
    context.commit("setLoading", false);
    context.commit("setLoading2", false);
    context.commit("setLoadingUser", false);
    context.commit("setActiveStep", 1);
  },
  UNSET_ERRORS(context, label) {
    context.commit("unsetQuickErrors", label);
    context.commit("unsetErrorState", label);
  },
  RESET_DEPART_FLIGHTS(context) {
    context.commit("resetDepartFlight");
    context.commit("resetDepartingFlights");
    context.commit("setStepIncomplete", "Departing");
    context.commit("resetConditions");
  },
  RESET_RETURN_FLIGHTS(context) {
    context.commit("resetReturnFlight");
    context.commit("resetReturningFlights");
    context.commit("setStepIncomplete", "Return");
    context.commit("resetConditions");
  },
  SET_DEPART_LOC(context, payload) {
    context.commit("setDepartLoc", payload);
  },
  SET_DEST_LOC(context, payload) {
    context.commit("setDestLoc", payload);
  }
};

const locations = [
  {
    label: "----",
    value: 0,
    departs_to: []
	},
	{
		label: "Victoria",
		value: 11,
		departs_to: [10]
	},
  {
    label: "Nanaimo",
    value: 5,
    departs_to: [10, 7]
  },
  {
    label: "Vancouver Harbour",
    value: 10,
    departs_to: [5, 1, 11]
  },
  {
    label: "Richmond (YVR)",
    value: 7,
    departs_to: [5, 1]
	},
  {
    label: "Ganges Harbour",
    value: 1,
    departs_to: [7, 10]
	}
];

var state = {
  active: 1,
  editMode: false,
  complete: false,
  layout: "simple-layout",
  timer: null,
  countdownTimer: "",
  showCountdownTimer: true,
  timeLimit: {
    value: (process.env.VUE_APP_DEVMODE == "true") ? 480 : 10,
    scale: "minutes"
  },
  mobileDevice: false,
  minMode: false,
  colMode: true,
  showForm: true,
  darkMode: false,
  devMode: process.env.VUE_APP_DEVMODE,
  restricted: false,
  loading: false,
  loading2: false,
  loadingUser: false,
  loadingLowest: false,
  lowestFares: {
    "D": [],
    "R": [],
    "DBase": null,
    "RBase": null
  },
  form: Routes,
  errors: [],
  user: {
    id: null,
    name_first: "",
    name_last: "",
    email: "",
    password: "",
    phone: {
      cell: "",
      alt: ""
    },
    address: {
      street: "",
      street2: "",
      city: "",
      country: "CA",
      province: "BC",
      postal_code: ""
    },
    credit_card: {
      cardholder_fn: "",
      cardholder_ln: "",
      number: "",
      expires: {
        mm: "",
        yy: ""
      },
      cvv: ""
    },
		has_prepaid: false,
		promocode: ""
  },
  form_steps_complete: [],
  form_fields: {
    b_id: null,
    dep_loc: 0,
    dest_loc: 0,
    dep_date: setDefaultDate(),
    ret_date: null,
    pax_a: 1,
    pax_c: 0,
    pax_i: 0,
    pax_a_r: 1,
    pax_c_r: 0,
    pax_i_r: 0,
    round_trip: false,
		use_prepaid: false,
		promocode: "",
		agree_to_terms: false,
		hcaptchaToken: null
  },
  line_items: null,
  samepassengers: true,
  locations: locations,
  departingFlights: null,
  departFlight: null,
  returningFlights: null,
  returnFlight: null,
	paymentError: null,
  loginDialog: false,
  menuDialog: false,
  contactDialog: false,
  devDialog: false,
  helpDialog: false,
  cargoDialog: false,
  showError: false,
  conditions: {
    senior: false,
    student: false,
    pets: false,
    dog: false,
    large_dog: false,
    cat: false,
    assistance: false
  },
  editBookingData: null
};

export default new Vuex.Store({
  strict: false,
  plugins: [createPersistedState()],
  state,
  getters: getters,
  mutations: mutations,
  actions: actions,
  computed: {}
});
